import React, { useEffect, useState } from "react";
import MoreOptions from "../../../../Components/Utils/MoreOptions";
import DataTable from "../../../../Components/Others/DataTable";
import ViewToggle from "../../../../Components/Utils/ViewToggle";
import {
  CancelButton,
  CreateButton,
  FilterButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation } from "react-router-dom";
import SearchBar from "../../../../Components/Utils/SearchBar";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import CustomDataTable from "../../../../Components/Others/CustomDataTable";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { useFormik } from "formik";
import * as yup from "yup";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { NuDate } from "../../../../Components/Utils/Input";
import NuAmount from "../../../../Components/Utils/NuAmount";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import MultiEditPO from "./MultiEditPO";
import { GetAccess, GetNotUseRole, GetRole, CheckEditAction, CheckDeleteAction } from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import { OrderFlowPO } from "../../../../Components/Others/OrderFlow";
import PremiumTable, { CopyButton } from "../../../../Components/Others/PremiumTable";
import { useDeleteData } from "../../../../Components/Hooks/useDeleteData";
import moment from "moment";

// Icons for Approval Status
const HourglassIcon = () => (
  <svg className="w-4 h-4 text-amber-500 animate-pulse shrink-0" viewBox="0 0 384 512" fill="currentColor" title="Pending">
    <path d="M360 0H24C10.7 0 0 10.7 0 24v16c0 13.3 10.7 24 24 24h16v96c0 56.6 32.7 105.6 80 128-47.3 22.4-80 71.4-80 128v96H24c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24h-16v-96c0-56.6-32.7-105.6-80-128 47.3-22.4 80-71.4 80-128V64h16c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24zm-80 448H104v-48c0-44.1 35.9-80 80-80s80 35.9 80 80v48zm0-240v16H104v-16c0-44.1 35.9-80 80-80s80 35.9 80 80z" />
  </svg>
);

const ApprovedIcon = () => (
  <svg className="w-4 h-4 text-emerald-500 shrink-0" viewBox="0 0 512 512" fill="currentColor" title="Approved">
    <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm108.384 186.758l-140.2 140.2c-4.7 4.7-12.3 4.7-17 0l-71.8-71.8c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l46.3 46.3 114.7-114.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17z" />
  </svg>
);

const RejectedIcon = () => (
  <svg className="w-4 h-4 text-red-500 shrink-0" viewBox="0 0 512 512" fill="currentColor" title="Rejected">
    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm88.3 325.3c4.7 4.7 4.7 12.3 0 17l-19.8 19.8c-4.7 4.7-12.3 4.7-17 0L256 312.8 204.5 364c-4.7 4.7-12.3 4.7-17 0l-19.8-19.8c-4.7-4.7-4.7-12.3 0-17l51.5-51.5-51.5-51.5c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0l51.5 51.5 51.5-51.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L297.2 256l57.1 57.3z" />
  </svg>
);

const VerifiedIcon = () => (
  <svg className="w-4 h-4 text-purple-500 shrink-0" viewBox="0 0 384 512" fill="currentColor" title="Verified">
    <path d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm108.3 186.7l-114.7 114.7c-4.7 4.7-12.3 4.7-17 0l-46.3-46.3c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l12.3 12.3 80.7-80.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17z" />
  </svg>
);

const ReviewedIcon = () => (
  <svg className="w-4 h-4 text-indigo-500 shrink-0" viewBox="0 0 384 512" fill="currentColor" title="Reviewed">
    <path d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm96-136.5V128H256V0h9.5c6.4 0 12.5 2.5 17 7l98.5 98.5c4.5 4.5 7 10.6 7 17z" />
  </svg>
);

const renderApprovalStatusIcon = (status) => {
  const s = String(status || "").toLowerCase().trim();
  if (s === "approved") return <ApprovedIcon />;
  if (s === "pending") return <HourglassIcon />;
  if (s === "rejected" || s === "declined") return <RejectedIcon />;
  if (s === "verified") return <VerifiedIcon />;
  if (s === "reviewed") return <ReviewedIcon />;
  return null;
};

const getPOStatusBadgeClass = (status) => {
  const s = String(status || "").toLowerCase().trim();
  switch (s) {
    case "completed":
    case "approved":
    case "po to supplier approved":
    case "delivered to customer":
    case "delivered to customer":
      return "bg-emerald-50 text-emerald-700 border-emerald-100";
    case "pending":
    case "order under customers clearance":
    case "under customer clearance":
      return "bg-amber-50 text-amber-700 border-amber-100";
    case "po received from customer":
      return "bg-indigo-50 text-indigo-700 border-indigo-100";
    case "lost the order":
      return "bg-rose-50 text-rose-700 border-rose-100";
    case "sales order released":
      return "bg-teal-50 text-teal-700 border-teal-100";
    case "po placed with supplier":
      return "bg-sky-50 text-sky-700 border-sky-100";
    case "order shipped":
      return "bg-blue-50 text-blue-700 border-blue-100";
    case "order received at warehouse":
    case "at warehouse":
      return "bg-violet-50 text-violet-700 border-violet-100";
    default:
      return "bg-gray-50 text-gray-600 border-gray-100";
  }
};

// PO Progress Timeline Component
const POProgressTimeline = ({ tracker }) => {
  const stepsByOrder = Object.fromEntries(
    tracker?.map((step) => [step.order, step]) || []
  );

  const isStepActiveFast = (order, statuses = []) =>
    statuses.includes(stepsByOrder?.[order]?.status);

  const rawActive6 = isStepActiveFast(6, ["PO Received from customer", "Lost the Order"]);
  const rawActive7 = isStepActiveFast(7, ["Sales Order Released"]);
  const rawActive8 = isStepActiveFast(8, ["PO to Supplier Approved"]);
  const rawActive9 = isStepActiveFast(9, ["PO placed with Supplier"]);
  const rawActive10 = isStepActiveFast(10, ["Order Shipped"]);
  const rawActive11 = isStepActiveFast(11, ["Order Under Customers clearance"]);
  const rawActive12 = isStepActiveFast(12, ["Order Received at Warehouse"]);
  const rawActive13 = isStepActiveFast(13, ["Delivered to Customer", "Delivered to Customer"]);

  const isActive13 = rawActive13 || stepsByOrder?.[13]?.date;
  const isActive12 = rawActive12 || stepsByOrder?.[12]?.date || isActive13;
  const isActive11 = rawActive11 || stepsByOrder?.[11]?.date || isActive12;
  const isActive10 = rawActive10 || stepsByOrder?.[10]?.date || isActive11;
  const isActive9 = rawActive9 || stepsByOrder?.[9]?.date || isActive10;
  const isActive8 = rawActive8 || stepsByOrder?.[8]?.date || isActive9;
  const isActive7 = rawActive7 || stepsByOrder?.[7]?.date || isActive8;
  const isActive6 = rawActive6 || stepsByOrder?.[6]?.date || isActive7;

  // Icons
  const poCustIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
    </svg>
  );
  const salesIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
    </svg>
  );
  const poApprIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
  const poSupIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
  );
  const shipIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1" />
    </svg>
  );
  const clearIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  );
  const warehouseIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
  );
  const deliverIcon = (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  );

  const steps = [
    {
      title: stepsByOrder?.[6]?.status === "PO Received from customer"
        ? "PO Received from customer"
        : stepsByOrder?.[6]?.status === "Lost the Order"
          ? "Lost the Order"
          : "PO Received / Lost Order",
      active: isActive6,
      date: stepsByOrder?.[6]?.date,
      icon: poCustIcon
    },
    { title: "Sales Order Released", active: isActive7, date: stepsByOrder?.[7]?.date, icon: salesIcon },
    { title: "PO to Supplier Approved", active: isActive8, date: stepsByOrder?.[8]?.date, icon: poApprIcon },
    { title: "PO placed with Supplier", active: isActive9, date: stepsByOrder?.[9]?.date, icon: poSupIcon },
    { title: "Order Shipped", active: isActive10, date: stepsByOrder?.[10]?.date, icon: shipIcon },
    { title: "Under Customer Clearance", active: isActive11, date: stepsByOrder?.[11]?.date, icon: clearIcon },
    { title: "At Warehouse", active: isActive12, date: stepsByOrder?.[12]?.date, icon: warehouseIcon },
    { title: "Delivered to Customer", active: isActive13, date: stepsByOrder?.[13]?.date, icon: deliverIcon },
  ];

  let activeCount = 0;
  if (isActive6) activeCount = 1;
  if (isActive7) activeCount = 2;
  if (isActive8) activeCount = 3;
  if (isActive9) activeCount = 4;
  if (isActive10) activeCount = 5;
  if (isActive11) activeCount = 6;
  if (isActive12) activeCount = 7;
  if (isActive13) activeCount = 8;

  const activePercent = activeCount > 1 ? ((activeCount - 1) / 7) * 100 : 0;
  const lastActiveIdx = activeCount - 1;

  return (
    <div className="w-full overflow-x-auto">
      <div className="relative py-4 pl-4 pr-10 w-max min-w-full">
        {/* Connecting Line Track Container */}
        <div className="absolute top-[38px] left-[38px] right-[62px] z-0 pointer-events-none">
          <div className="relative w-full h-[2px]">
            <div className="absolute left-0 right-0 top-0 bottom-0 bg-gray-200" />
            <div
              className="absolute left-0 top-0 bottom-0 bg-green-500 transition-all duration-500"
              style={{ width: `${activePercent}%` }}
            />
          </div>
        </div>

        {/* Row of Step Columns */}
        <div className="relative flex justify-between items-start w-full min-w-max z-10">
          {steps.map((step, idx) => {
            const formattedDate = step.active && step.date ? moment(step.date).format("DD-MMM-YYYY") : "--";
            const formattedTime = step.active && step.date ? moment(step.date).format("hh:mm A") : "--";

            let alignClass = "items-center text-center";
            if (idx === 0) {
              alignClass = "items-start text-left";
            } else if (idx === 7) {
              alignClass = "items-end text-right";
            }

            return (
              <div key={idx} className={`flex flex-col w-[120px] shrink-0 ${alignClass}`}>
                <div className="h-11 w-11 flex items-center justify-center mb-2 relative">
                  {idx === lastActiveIdx && (
                    <div className="absolute w-9 h-9 rounded-full bg-green-900 animate-ping z-0 pointer-events-none" />


                  )}
                  <div
                    className={`w-10 h-10 rounded-full flex items-center justify-center border-2 z-10 transition-all duration-300 ${step.active
                      ? "border-baseColor-primary bg-baseColor-primary text-white shadow-[0_0_10px_rgba(4,129,120,0.25)]"
                      : "bg-white border-gray-200 text-gray-400"
                      }`}
                  >
                    {step.icon}
                  </div>
                </div>

                {/* Label and Date */}
                <p className={`text-[12px] font-semibold leading-snug ${step.active ? "text-gray-800" : "text-gray-400"}`}>
                  {step.title}
                </p>
                <p className="text-[12px] text-gray-600 font-semibold mt-1 leading-tight">
                  {formattedDate}
                </p>
                <p className="text-[12px] text-gray-600 font-semibold leading-tight">
                  {formattedTime}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

// PO Table Row Component
const POTableRow = ({
  row,
  isSelected,
  onSelect,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
}) => {
  const formattedDate = row.date ? moment(row.date).format("DD-MMM-YYYY") : "--";
  const formattedDeliveryDate = row.deliveryDate ? moment(row.deliveryDate).format("DD-MMM-YYYY") : "--";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/PO/" + `${row.poId}`, setIsModalOpen);
  return (
    <>
      <tr className="bg-white hover:bg-white/80 transition-colors align-middle border-b border-gray-100">
        {/* Checkbox */}
        <td className="p-4 text-center align-middle border-t border-l border-gray-200/60 rounded-tl-xl">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelect}
            className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer"
          />
        </td>

        {/* YPR */}
        <td className="p-4 align-middle border-t border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
          <div className="flex items-center gap-1.5">
            {row.prId ? (
              <Link
                to={`/procurement/purchase-requests/view/${row.prId}`}
                className="hover:underline text-sm font-bold text-gray-800"
              >
                {row.prRrf || "N/A"}
              </Link>
            ) : (
              <span className="text-sm font-bold text-gray-800">
                {row.prRrf || "N/A"}
              </span>
            )}
            <CopyButton text={row.prRrf} />
          </div>
        </td>

        {/* PO NO. */}
        <td className="p-4 align-middle border-t border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
          <div className="flex items-center gap-1.5">
            <Link
              to={`/procurement/purchase-order/view/${row.poId}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="hover:underline text-sm font-bold text-gray-800"
            >
              {row.ref || "N/A"}
            </Link>
            <CopyButton text={row.ref} />
          </div>
        </td>

        {/* Date */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
          {formattedDate}
        </td>

        {/* Supplier */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600">
          {row.vendorName || "N/A"}
        </td>

        {/* Amount */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-bold text-gray-800">
          <NuAmount currency={row["vendorCurrency"] || row["currency"]} value={row.totalPrice || 0} />
        </td>

        {/* Payment Status */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
          <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-bold ${row.paymentStatus === "Paid"
            ? "text-emerald-600 bg-emerald-50"
            : row.paymentStatus === "Partially Paid"
              ? "text-blue-600 bg-blue-50"
              : "text-amber-600 bg-amber-50"
            }`}>
            {row.paymentStatus || "N/A"}
          </span>
        </td>

        {/* Purchaser */}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600">
          {GetNotUseRole("procurement") ? (row.purchaser?.name || "N/A") : (row.preparedByName || "N/A")}
        </td>

        {/* Status */}
        <td className="p-4 align-middle border-t border-gray-200/60 whitespace-nowrap">
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${getPOStatusBadgeClass(row.status)}`}>
            {row.status || "N/A"}
          </span>
        </td>

        {/* Action Buttons */}
        <td className="p-4 text-center align-middle border-t border-r border-gray-200/60 rounded-tr-xl">
          <div className="flex items-center justify-center gap-1.5">
            {/* Approval Status Icon */}
            {renderApprovalStatusIcon(row.approvalStatus)}

            {/* View */}
            <Link
              to={`/procurement/purchase-order/view/${row.poId}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="border border-blue-200 text-blue-600 hover:bg-blue-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="View details"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </Link>
            {/* Edit */}
            {CheckEditAction(row, "Purchase Order", canEdit) && (
              <Link
                to={`/procurement/purchase-order/edit/${row.poId}`}
                state={{
                  data: row,
                  from: "/procurement/purchase-order",
                  pageIndex: pageIndex,
                  searchQuery: searchQuery,
                }}
                className="border border-sky-200 text-[#0ea5e9] hover:bg-sky-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
                title="Edit PO"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              </Link>
            )}
            {/* Delete */}
            {CheckDeleteAction(row, canDelete) && (
              <button
                onClick={() => setIsModalOpen(true)}
                className="border border-red-200 text-red-500 hover:bg-red-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
                title="Delete PO"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            )}
          </div>
        </td>
      </tr>
      <tr className="bg-white">
        <td colSpan={10} className="px-4 py-3 bg-[#FAFAFC]/40 rounded-bl-xl rounded-br-xl border-t border-gray-100 border-b border-gray-200/40">
          <POProgressTimeline tracker={row.tracker} />
        </td>
      </tr>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.ref} will be removed from PO!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

// PO Card Component
const POCard = ({
  row,
  isSelected,
  onSelect,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
}) => {
  const formattedDate = row.date ? moment(row.date).format("DD-MMM-YYYY") : "--";
  const formattedDeliveryDate = row.deliveryDate ? moment(row.deliveryDate).format("DD-MMM-YYYY") : "--";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/PO/" + `${row.poId}`, setIsModalOpen);
  return (
    <div className="relative border border-y-gray-200/50 border-r-gray-200/50  shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] transition-all duration-300 rounded-2xl bg-white p-5 flex flex-col gap-4 overflow-hidden border-l-4 border-l-violet-500">
      {/* Card Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:gap-4">
        <div className="flex items-center gap-2.5">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelect}
            className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer"
          />
          <div className="flex flex-col">
            <div className="flex items-center gap-1.5">
              <Link
                to={`/procurement/purchase-order/view/${row.poId}`}
                state={{
                  data: row,
                  pageIndex: pageIndex,
                  searchQuery: searchQuery,
                }}
                className="text-gray-800 font-bold hover:underline text-sm"
              >
                {row.ref || "N/A"}
              </Link>
              <CopyButton text={row.ref} />
            </div>
            <div className="flex items-center gap-1 mt-0.5">
              <span className="text-[10px] text-gray-500 font-bold">
                YPR:{" "}
                {row.prId ? (
                  <Link
                    to={`/procurement/purchase-requests/view/${row.prId}`}
                    className="hover:underline text-gray-800"
                  >
                    {row.prRrf || "N/A"}
                  </Link>
                ) : (
                  row.prRrf || "N/A"
                )}
              </span>
              <CopyButton text={row.prRrf} />
            </div>
            <span className="text-[10px] text-gray-400 font-bold mt-0.5">Supplier: {row.vendorName || "N/A"}</span>
          </div>
        </div>

        {/* Status & Approval Icon */}
        <div className="flex items-center gap-2">
          {renderApprovalStatusIcon(row.approvalStatus)}
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${getPOStatusBadgeClass(row.status)}`}>
            {row.status || "N/A"}
          </span>
        </div>
      </div>

      {/* Middle Grid */}
      <div className="bg-[#FAFAFC]/60 rounded-xl p-3.5 border border-gray-100 flex justify-between items-center gap-2 text-xs">
        <div className="flex flex-col gap-0.5 flex-1">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Date</span>
          <span className="font-bold text-gray-700">{formattedDate}</span>
        </div>
        <div className="w-[1px] h-8 bg-gray-100" />
        <div className="flex flex-col gap-0.5 flex-1 pl-2">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Delivery Date</span>
          <span className="font-bold text-gray-700">{formattedDeliveryDate}</span>
        </div>
      </div>

      {/* Amount details */}
      <div className="flex justify-between items-center px-1 text-xs text-gray-600 font-medium">
        <span>Total Amount:</span>
        <span className="font-extrabold text-gray-800 text-sm">
          <NuAmount currency={row["vendorCurrency"] || row["currency"]} value={row.totalPrice || 0} />
        </span>
      </div>

      {/* Progress Timeline */}
      <div className="border-t border-gray-100 pt-2">
        <POProgressTimeline tracker={row.tracker} />
      </div>

      {/* Action Buttons Row */}
      <div className="flex items-center justify-between border-t border-gray-100 pt-3 mt-1 gap-1.5 flex-wrap sm:flex-nowrap">
        <Link
          to={`/procurement/purchase-order/view/${row.poId}`}
          state={{
            data: row,
            pageIndex: pageIndex,
            searchQuery: searchQuery,
          }}
          className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
          title="View Details"
        >
          <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          <span className="hidden sm:inline">View Details</span>
        </Link>
        <div className="flex items-center gap-1.5">
          {CheckEditAction(row, "Purchase Order", canEdit) && (
            <Link
              to={`/procurement/purchase-order/edit/${row.poId}`}
              state={{
                data: row,
                from: "/procurement/purchase-order",
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
              title="Edit"
            >
              <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              <span className="hidden sm:inline">Edit</span>
            </Link>
          )}
          {CheckDeleteAction(row, canDelete) && (
            <button
              onClick={() => setIsModalOpen(true)}
              className="border border-red-100 text-red-500 hover:bg-red-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
              title="Delete"
            >
              <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              <span className="hidden sm:inline">Delete</span>
            </button>
          )}
        </div>
      </div>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.ref} will be removed from PO!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </div>
  );
};

// function PoIndex() {
//   const location = useLocation();
//   const state = location.state;

//   const currentPage = location.state?.currentPage;
//   const searchQuery = location.state?.searchQuery;
//   const [page, setPage] = useState(currentPage || 1);
//   const [pageCount, setPageCount] = useState(
//     localStorage.getItem("perPageView") || 20,
//   );
//   const [filter, setFilter] = useState(state?.approvalStatus ? true : false);
//   const [showFilterDialog, setShowFilterDialog] = useState(false);
//   const [viewMode, setViewMode] = useState(localStorage.getItem("poViewMode") || "table");
//   const { value: paymentTerms } = useFetchMDIndex(
//     `/dropdown/dropdown-details/`,
//     "PaymentTerms_po",
//     showFilterDialog,
//   );
//   // const {value:deliveryTerms} = useFetchMDIndex(`/dropdown/dropdown-details/`,'deliveryTerms_po',showFilterDialog)
//   const { value: paymentStatus } = useFetchMDIndex(
//     `/dropdown/dropdown-details/`,
//     "paymentStatus_po",
//     showFilterDialog,
//   );
//   const { value: Status } = useFetchMDIndex(
//     `/dropdown/dropdown-details/`,
//     "Status_po",
//     showFilterDialog,
//   );
//   const { value: deliveryTerms, getData: refdeliveryTerms } = useFetchMDIndex(
//     `/dropdown/dropdown-details/`,
//     "DeliveryTerms_Supplierqoutes",
//     showFilterDialog,
//   );
//   const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
//   const [filterProps, setFilterProps] = useState({
//     status: "",
//     requestedDeliveryDateFrom: "",
//     requestedDeliveryDateTo: "",
//     paymentStatus: "",
//     fromDate: "",
//     toDate: "",
//     paymentTerms: "",
//     deliveryTerms: "",
//     approvalStatus: "",
//     purchaser: "",
//   });
//   const [params, setParams] = useState({
//     page: page,
//     per_page: pageCount,
//     search: searchQuery || "",

//     status: "",
//     approvalStatus: state?.approvalStatus ? state.approvalStatus : "",

//     requestedDeliveryDateFrom: "",
//     requestedDeliveryDateTo: "",
//     paymentStatus: "",
//     fromDate: "",
//     toDate: "",
//     paymentTerms: "",
//     deliveryTerms: "",
//   });
//   const clearFilter = () => {
//     setParams({
//       ...params,
//       status: "",
//       requestedDeliveryDateFrom: "",
//       requestedDeliveryDateTo: "",
//       approvalStatus: "",

//       paymentStatus: "",
//       fromDate: "",
//       toDate: "",
//       paymentTerms: "",
//       deliveryTerms: "",
//     });
//     setFilter(false);
//     formik.values.status = "";
//     formik.values.requestedDeliveryDateFrom = "";
//     formik.values.requestedDeliveryDateTo = "";
//     formik.values.paymentStatus = "";
//     formik.values.fromDate = "";
//     formik.values.toDate = "";
//     formik.values.paymentTerms = "";
//     formik.values.deliveryTerms = "";
//     formik.values.approvalStatus = "";
//     formik.values.purchaser = "";
//   };

//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues: filterProps,
//     validateOnChange: false,
//     validateOnBlur: false,
//     validationSchema: yup.object({
//       // email: yup.string().required('Email is required!'),
//     }),
//     onSubmit: async (value, { resetForm }) => {
//       setParams({
//         ...params,
//         status: value.status,
//         deliveryTerms: value.deliveryTerms,
//         paymentTerms: value.paymentTerms,
//         toDate: value.toDate,
//         fromDate: value.fromDate,
//         paymentStatus: value.paymentStatus,
//         requestedDeliveryDateTo: value.requestedDeliveryDateTo,
//         requestedDeliveryDateFrom: value.requestedDeliveryDateFrom,
//         approvalStatus: value.approvalStatus,
//         purchaser: value.purchaser,
//       });
//       closeFilterDialog();
//       setFilter(true);
//       setFilterProps({
//         status: "",
//         requestedDeliveryDateFrom: "",
//         requestedDeliveryDateTo: "",
//         paymentStatus: "",
//         fromDate: "",
//         toDate: "",
//         paymentTerms: "",
//         deliveryTerms: "",
//         approvalStatus: "",
//       });
//     },
//   });

//   const { data, totalCount, getData, dataLoading } = UseGetDataSearch(
//     "/PO/",
//     params,
//   );
//   const defaultHeader = [
//     // {
//     //   title: "ID",
//     //   width: "5%",
//     //   field: "poId",
//     //   textAlign: "center",
//     //   rowAlign: "center",
//     // },
//     {
//       title: "YPR",
//       width: "10%",
//       isLink: true,
//       id: "prId",
//       link: "/procurement/purchase-requests/view/",

//       field: "prRrf",
//       textAlign: "center",
//       rowAlign: "center",
//     },
//     {
//       title: "PO NO. ",
//       width: "10%",
//       isLink: true,
//       id: "poId",
//       link: "/procurement/purchase-order/view/",
//       field: "ref",
//       textAlign: "center",
//       rowAlign: "center",
//     },

//     {
//       title: "Date",
//       type: "date",
//       width: "10%",
//       field: "date",
//       textAlign: "center",
//       rowAlign: "center",
//     },
//     // {
//     //   title: "Purchasers",
//     //   width: "10%",
//     //       field: "purchasers",
//     //   textAlign: "center",
//     //   rowAlign: "center",
//     // },
//     {
//       title: "Supplier ",
//       width: "10%",
//       field: "vendorName",
//       textAlign: "center",
//       rowAlign: "center",
//     },
//     {
//       title: "Amount",
//       width: "10%",
//       type: "amount",
//       field: "totalPrice",
//       textAlign: "center",
//       rowAlign: "center",
//     },
//     {
//       title: "Payment Status",
//       width: "10%",
//       field: "paymentStatus",
//       textAlign: "center",
//       rowAlign: "center",
//     },
//     ...(GetNotUseRole("procurement")
//       ? [
//         {
//           title: "Purchaser",
//           width: "10%",
//           field: "purchaser.name",
//           textAlign: "center",
//           rowAlign: "center",
//         },
//       ]
//       : [
//         {
//           title: "Prepared By ",
//           width: "10%",
//           field: "preparedByName",
//           textAlign: "center",
//           rowAlign: "center",
//         },
//       ]),
//     {
//       title: "Status",
//       width: "10%",
//       field: "status",
//       textAlign: "center",
//       rowAlign: "center",
//     },
//     {
//       title: "Action",
//       width: "5%",
//       field: "action",
//       textAlign: "center",
//       rowAlign: "center",
//       contents: {
//         // fetcher:getData,
//         id: "poId",
//         removeValue: "ref",
//         url: `/PO/`,
//         moduleName: "Purchase Order",
//         from: `/procurement/purchase-order`,
//         editLink: "/procurement/purchase-order/edit/",
//         viewLink: "/procurement/purchase-order/view/",
//         EmailRequired: true,
//       },
//     },
//   ];
//   const availableHeaders = [
//     // {
//     //   title: "ID",
//     //   width: "5%",
//     //   field: "poId",
//     //   textAlign: "center",
//     //   rowAlign: "center",
//     // },
//     {
//       title: "YPR",
//       width: "10%",
//       isLink: true,
//       id: "prId",
//       link: "/procurement/purchase-requests/view/",

//       field: "prRrf",
//       textAlign: "center",
//       rowAlign: "center",
//     },
//     {
//       title: "PO NO. ",
//       width: "10%",
//       isLink: true,
//       id: "poId",
//       link: "/procurement/purchase-order/view/",
//       field: "ref",
//       textAlign: "center",
//       rowAlign: "center",
//     },

//     {
//       title: "Date",
//       type: "date",
//       width: "10%",
//       field: "date",
//       textAlign: "center",
//       rowAlign: "center",
//     },
//     // {
//     //   title: "Purchasers",
//     //   width: "10%",
//     //       field: "purchasers",
//     //   textAlign: "center",
//     //   rowAlign: "center",
//     // },
//     {
//       title: "Supplier ",
//       width: "10%",
//       field: "vendorName",
//       textAlign: "center",
//       rowAlign: "center",
//     },
//     {
//       title: "Amount",
//       width: "10%",
//       type: "amount",
//       field: "totalPrice",
//       textAlign: "center",
//       rowAlign: "center",
//     },
//     {
//       title: "Payment Status",
//       width: "10%",
//       field: "paymentStatus",
//       textAlign: "center",
//       rowAlign: "center",
//     },
//     ...(GetNotUseRole("procurement")
//       ? [
//         {
//           title: "Purchaser",
//           width: "10%",
//           field: "purchaser.name",
//           textAlign: "center",
//           rowAlign: "center",
//         },
//       ]
//       : [
//         {
//           title: "Prepared By ",
//           width: "10%",
//           field: "preparedByName",
//           textAlign: "center",
//           rowAlign: "center",
//         },
//       ]),
//     {
//       title: "Status",
//       width: "10%",
//       field: "status",
//       textAlign: "center",
//       rowAlign: "center",
//     },

//     {
//       title: "Requested Delivery",
//       type: "date",
//       width: "10%",
//       field: "requestedDeliveryDate",
//       textAlign: "center",
//       rowAlign: "center",
//     },

//     // {
//     //   title: "Payment Terms",
//     //   width: "10%",
//     //   field: "paymentTerms",
//     //   textAlign: "center",
//     //   rowAlign: "center",
//     // },
//     {
//       title: "Delivery Terms",
//       width: "10%",
//       field: "deliveryTerms",
//       textAlign: "center",
//       rowAlign: "center",
//     },
//     {
//       title: "Requested By",
//       width: "10%",
//       field: "requestedBy",
//       textAlign: "center",
//       rowAlign: "center",
//     },

//     {
//       title: "Approved By",
//       width: "10%",
//       field: "approvedBy",
//       textAlign: "center",
//       rowAlign: "center",
//     },
//     // {
//     //   title: "Comments",
//     //   width: "10%",
//     //   field: "comments",
//     //   textAlign: "center",
//     //   rowAlign: "center",
//     // },
//     {
//       title: "Action",
//       width: "5%",
//       field: "action",
//       textAlign: "center",
//       rowAlign: "center",
//       contents: {
//         id: "poId",
//         removeValue: "ref",
//         url: `/PO/`,
//         moduleName: "Purchase Order",
//         from: `/procurement/purchase-order`,
//         editLink: "/procurement/purchase-order/edit/",
//         viewLink: "/procurement/purchase-order/view/",
//         EmailRequired: true,
//       },
//     },
//   ];
// }

function PoIndex() {
  const location = useLocation();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;

  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20,
  );

  const state = location.state;

  const [filter, setFilter] = useState(state?.approvalStatus ? true : false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [viewMode, setViewMode] = useState(localStorage.getItem("poViewMode") || "table");
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobileScreen ? "card" : viewMode;

  const { value: paymentTerms } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "PaymentTerms_po",
    showFilterDialog,
  );
  const { value: paymentStatus } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "paymentStatus_po",
    showFilterDialog,
  );
  const { value: Status } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Status_po",
    showFilterDialog,
  );
  const { value: deliveryTerms } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "DeliveryTerms_Supplierqoutes",
    showFilterDialog,
  );
  const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
  const [filterProps, setFilterProps] = useState({
    status: "",
    requestedDeliveryDateFrom: "",
    requestedDeliveryDateTo: "",
    paymentStatus: "",
    fromDate: "",
    toDate: "",
    paymentTerms: "",
    deliveryTerms: "",
    approvalStatus: "",
    purchaser: "",
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",
    status: "",
    approvalStatus: state?.approvalStatus ? state.approvalStatus : "",
    requestedDeliveryDateFrom: "",
    requestedDeliveryDateTo: "",
    paymentStatus: "",
    fromDate: "",
    toDate: "",
    paymentTerms: "",
    deliveryTerms: "",
  });
  const clearFilter = () => {
    setParams({
      ...params,
      status: "",
      requestedDeliveryDateFrom: "",
      requestedDeliveryDateTo: "",
      approvalStatus: "",
      paymentStatus: "",
      fromDate: "",
      toDate: "",
      paymentTerms: "",
      deliveryTerms: "",
      purchaser: "",
    });
    formik.values.status = "";
    formik.values.approvalStatus = "";
    formik.values.requestedDeliveryDateFrom = "";
    formik.values.requestedDeliveryDateTo = "";

    formik.values.paymentStatus = "";
    formik.values.fromDate = "";
    formik.values.toDate = "";
    formik.values.paymentTerms = "";
    formik.values.deliveryTerms = "";
    formik.values.purchaser = "";

    setFilter(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({}),
    onSubmit: async (value, { resetForm }) => {
      setParams({
        ...params,
        status: value.status,
        approvalStatus: value.approvalStatus,
        requestedDeliveryDateFrom: value.requestedDeliveryDateFrom,
        requestedDeliveryDateTo: value.requestedDeliveryDateTo,
        paymentStatus: value.paymentStatus,
        fromDate: value.fromDate,
        toDate: value.toDate,
        paymentTerms: value.paymentTerms,
        deliveryTerms: value.deliveryTerms,
        purchaser: value.purchaser,
        page: 1,
      });
      setPage(1);

      closeFilterDialog();
      setFilter(true);
    },
  });

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch(
    "/PO/",
    params,
  );

  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
      NewId = listofNumbers.filter((Temp) => Temp !== value);
      setListofNumbers(NewId);
    } else {
      setListofNumbers([...listofNumbers, value]);
    }
  };

  const selectMultipleFunction = (e) => {
    if (e.target.checked) {
      setListofNumbers(fullList);
    } else {
      setListofNumbers([]);
    }
  };

  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        tempArr.push(i?.poId);
      });
    setFullList(tempArr);
  }, [data]);

  const canEdit = GetAccess("purchase_order_edit") || GetRole();
  const canDelete = GetAccess("purchase_order_delete") || GetRole();
  const { handle: handleDelete } = useDeleteData(getData);

  return (
    <div className="w-full h-full p-2 sm:px-4">
      <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb
            items={[{ name: "Procurement" }, { name: "Purchase Order" }]}
          />
          <div className="flex md:hidden items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
            {GetAccess("purchase_order_create") && (
              <Link to="/procurement/purchase-order/create">
                <CreateButton label="PO" />
              </Link>
            )}
          </div>
        </div>

        <div className="w-full md:w-auto flex flex-wrap md:flex-nowrap items-center gap-2">
          <div className="w-full md:w-fit">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1);
              }}
              value={params.search}
            />
          </div>
          <div className="hidden md:flex items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
          </div>

          {/* Table / Card View Toggle */}
          <ViewToggle
            viewMode={effectiveViewMode}
            onViewChange={(mode) => setViewMode(mode)}
            storageKey="poViewMode"
          />

          <div className="hidden md:flex items-center gap-2">
            {GetAccess("purchase_order_create") && (
              <Link to="/procurement/purchase-order/create">
                <CreateButton label="PO" />
              </Link>
            )}
          </div>
        </div>
      </div>
      <PremiumTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        // viewMode={viewMode}
        viewMode={effectiveViewMode}
        headers={[
          { title: "YPR", width: "160px" },
          { title: "PO NO.", width: "160px" },
          { title: "Date", width: "130px" },
          { title: "Supplier", width: "auto" },
          { title: "Amount", width: "140px" },
          { title: "Payment Status", width: "140px" },
          ...(GetNotUseRole("procurement")
            ? [{ title: "Purchaser", width: "180px" }]
            : [{ title: "Prepared By", width: "180px" }]),
          { title: "Status", width: "120px" },
          { title: "Action", align: "center", width: "120px" }
        ]}
        renderRow={(row, idx) => (
          <POTableRow
            row={row}
            isSelected={listofNumbers.includes(row.poId)}
            onSelect={() => selectOneFunction(row.poId)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
          />
        )}
        renderCard={(row, idx) => (
          <POCard
            row={row}
            isSelected={listofNumbers.includes(row.poId)}
            onSelect={() => selectOneFunction(row.poId)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
          />
        )}
        dataLoading={dataLoading}
        listofNumbers={listofNumbers}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
        multiEditLabel="Multi Edit"
      />
      {showFilterDialog && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-xs z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-[92vw] sm:w-[520px] md:w-[620px] max-w-full max-h-[85vh] bg-white p-5 sm:p-6 rounded-2xl shadow-2xl overflow-y-auto flex flex-col">
            <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-4">
              <h2 className="text-lg font-bold text-gray-800">Filter PO</h2>
              <button
                onClick={closeFilterDialog}
                type="button"
                className="text-gray-400 hover:text-gray-600 p-1 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <form onSubmit={formik.handleSubmit} className="flex flex-col gap-3">
              <div className="flex flex-col sm:flex-row flex-wrap -mx-2">
                <div className="w-full px-2 mb-2">
                  <p className="text-xs font-semibold text-gray-700 mb-1">Requested Delivery Date</p>
                  <div className="flex gap-2">
                    <NuDate
                      label="From"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="requestedDeliveryDateFrom"
                      width="w-1/2"
                    />
                    <NuDate
                      label="To"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="requestedDeliveryDateTo"
                      width="w-1/2"
                    />
                  </div>
                </div>
                <div className="w-full px-2 mb-2">
                  <p className="text-xs font-semibold text-gray-700 mb-1">Date Range</p>
                  <div className="flex gap-2">
                    <NuDate
                      label="From"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="fromDate"
                      width="w-1/2"
                    />
                    <NuDate
                      label="To"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="toDate"
                      width="w-1/2"
                    />
                  </div>
                </div>
                <FormikSelectTwo
                  type="text"
                  label="Delivery Terms"
                  placeholder="Choose"
                  Options={deliveryTerms}
                  formik={formik}
                  name="deliveryTerms"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Payment Terms"
                  placeholder="Choose"
                  Options={paymentTerms}
                  formik={formik}
                  name="paymentTerms"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Payment Status"
                  placeholder="Payment Status"
                  Options={paymentStatus}
                  formik={formik}
                  name="paymentStatus"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Status"
                  Options={Status}
                  formik={formik}
                  name="status"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Purchaser"
                  placeholder="Purchaser"
                  Options={RFQAssignee}
                  formik={formik}
                  name="purchaser"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Approval Status"
                  placeholder="Approval Status"
                  Options={[
                    { value: "Pending", label: "Pending" },
                    { value: "Reviewed", label: "Reviewed" },
                    { value: "Verified", label: "Verified" },
                    { value: "Approved", label: "Approved" },
                  ]}
                  formik={formik}
                  name="approvalStatus"
                  width="w-full sm:w-1/2"
                  px="2"
                />
              </div>
              <div className="flex justify-end gap-2.5 pt-4 mt-2 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
      {showEdit && (
        <MultiEditPO
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => { }}
        closeModal={() => setShowDelete(false)}
      />
    </div>
  );
}

export default PoIndex;
